import React, { PureComponent } from 'react'
import posed from 'react-pose'

// This is a hack because PoseGroup wasn't working.
// Dig in later.

const ParentPose = posed.div({
  enter: {
    delayChildren: 100,
    staggerChildren: 50
  },
  exit: {}
})

class TransitionGroup extends PureComponent {
  state = { enter: false }

  componentDidMount() {
    this.setState({ enter: true })
  }

  componentWullUnmount() {
    this.setState({ enter: false })
  }

  render() {
    const { enter } = this.state

    return (
      <ParentPose pose={enter ? 'enter' : 'exit'}>
        {this.props.children}
      </ParentPose>
    )
  }
}

export default TransitionGroup



// WEBPACK FOOTER //
// ./src/components/animation/TransitionGroup.js